document.addEventListener('DOMContentLoaded', () => {
  const cartForm = document.getElementById('cart');
  if (!cartForm) return;

  let isUpdating = false;

  async function updateCart(line, quantity) {
    if (isUpdating) return;
    isUpdating = true;
    document.documentElement.classList.add('is-cart-reloading');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity)
        })
      });

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      window.location.reload();
    } catch (error) {
      console.error(error);
      document.documentElement.classList.remove('is-cart-reloading');
      isUpdating = false;
      alert('הייתה שגיאה בעדכון הכמות בעגלה');
    }
  }

  document.addEventListener('click', (event) => {
    const removeBtn = event.target.closest('.cart-item__remove--media');
    if (removeBtn) {
      event.preventDefault();
      const line = removeBtn.dataset.line;
      updateCart(line, 0);
      return;
    }

    const qtyBtn = event.target.closest('.cart-quantity .quantity__button');
    if (!qtyBtn) return;

    event.preventDefault();

    const wrap = qtyBtn.closest('.cart-quantity');
    const input = wrap.querySelector('.quantity__input');
    const line = input.dataset.line;
    let value = parseInt(input.value, 10) || 1;

    if (qtyBtn.dataset.action === 'plus') {
      value += 1;
    } else {
      value = Math.max(1, value - 1);
    }

    input.value = value;
    updateCart(line, value);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.cart-quantity .quantity__input');
    if (!input) return;

    let value = parseInt(input.value, 10);
    if (isNaN(value) || value < 1) value = 1;

    input.value = value;
    updateCart(input.dataset.line, value);
  });
});